import RootStore from 'RootStore';

class ShopService {
    static getProduct = (productSlug) => {
        const store = RootStore.getStore().getState();

        const {
            shop,
        } = store;

        const {
            products,
        } = shop;

        return products[productSlug] || {};
    };

    static getCartOverviewInText = () => {
        const state = RootStore.getStore().getState();
        const {
            shop,
        } = state;

        const {
            cart,
        } = shop;

        let text = '';

        Object.values(cart).forEach((item) => {
            const {
                productSlug,
                price,
                amount,
            } = item;
            const product = ShopService.getProduct(productSlug);

            text += `${product.title} \n`;
            text += `€${price} * ${amount} = €${price * amount} \n \n`;
        });

        return text;
    }
}

export default ShopService;



// WEBPACK FOOTER //
// ./resources/components/shop/ShopService.js